import { render } from "./costsSection.vue?vue&type=template&id=1f82dd2a&scoped=true"
import script from "./costsSection.vue?vue&type=script&lang=js"
export * from "./costsSection.vue?vue&type=script&lang=js"

import "./costsSection.vue?vue&type=style&index=0&id=1f82dd2a&scoped=true&lang=css"

import exportComponent from "/Users/content/Documents/Biggie/triple_palm/photography-landing-page-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f82dd2a"]])

export default __exports__